import '../css/Footer.css'

export function Footer(){
    return(
            <footer>
                For Concerns or Inquiries, Please Use The Following Contact information. 
                <br/><t/>Email: contact@AbbeyCA.com
                <br/><t/><a href='tel:916-936-1191' style={{color: '#FFFFFF'}}>Phone: (916) 936-1191</a>
            </footer>
        );
    }